module.exports = __webpack_public_path__ + "static/img/tianjian2.b0ee329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian2.png
// module id = mp2m
// module chunks = 19